import styled, { css } from 'styled-components';
import { Button, Select } from 'antd';

export const Container = styled.div`
    background: ${({ theme }) => theme.colors.componentBackground};
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const TopRow = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
`;

export const FilterSelect = styled(Select)`
    width: 170px;
    flex: 0 0 170px;
    height: 42px;

    .ant-select-selector {
        height: 42px !important;
        border-radius: 6px !important;
        display: flex;
        align-items: center;
    }

    .ant-select-selection-item {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const FiltersRow = styled.div<{ $equalWidth?: boolean }>`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;

    ${({ $equalWidth }) =>
        $equalWidth &&
        css`
            flex-wrap: nowrap;

            ${FilterSelect} {
                flex: 1 1 0;
                width: auto;
                min-width: 0;
            }
        `}
`;

export const AddButton = styled(Button)`
    height: 42px;
    flex-shrink: 0;
`;

export const ResultLineActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
`;

export const ViewToggle = styled.div`
    display: flex;
    background: ${({ theme }) => theme.colors.colorFillTertiary};
    border-radius: 8px;
    padding: 3px;
    gap: 2px;
`;

export const ViewToggleButton = styled.button<{ active: boolean }>`
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${({ active, theme }) =>
        active ? theme.colors.componentBackground : 'transparent'};
    color: ${({ active, theme }) =>
        active ? theme.colors.accentColor : theme.colors.lightFont};
    box-shadow: ${({ active, theme }) =>
        active ? theme.colors.boxShadowSecondary : 'none'};
`;

export const ResultLine = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.lightFont};
`;
